import axios from 'axios';
import _ from 'lodash';
import config from '@/config';
import * as constants from '../constants';

const { core } = config;
const { endpoints } = core;

const fetchPicture = ({ dispatch }, id) => new Promise((resolve, reject) => {
  if (!id) {
    reject(new Error('No picture ID'));
  }
  axios({ url: endpoints.picture(id) })
    .then((resp) => {
      resolve(resp.data);
    })
    .catch((err) => {
      dispatch('showGeneralError', { err });
      reject(err);
    });
});

const fetchCountries = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.countries })
    .then(({ data }) => {
      commit(constants.CORE_COUNTRIES, data);
      resolve(data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchConfig = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.config })
    .then(({ data }) => {
      commit(constants.CORE_CONFIG, data);
      resolve(data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchStateProvince = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.stateProvince })
    .then(({ data }) => {
      commit(constants.CORE_STATE_PROVINCE, data);
      resolve(data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchWarehouses = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.warehouses })
    .then(({ data }) => {
      commit(constants.CORE_WAREHOUSES, data);
      resolve(data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchLanguages = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.languages })
    .then(({ data }) => {
      commit(constants.CORE_LANGUAGES, data);
      resolve(data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchStores = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.stores })
    .then(({ data }) => {
      commit(constants.CORE_STORES, data);
      resolve(data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchCurrentStore = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.store })
    .then(({ data }) => {
      commit(constants.CORE_STORE, data);
      resolve(data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchCurrencies = ({ commit, dispatch }) => new Promise((resolve, reject) => {
  axios({ url: endpoints.currencies })
    .then(({ data }) => {
      commit(constants.CORE_CURRENCIES, data);
      resolve(data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const fetchSlider = ({ dispatch }, id) => new Promise((resolve, reject) => {
  axios({ url: endpoints.slider(id) })
    .then(({ data }) => {
      resolve(data);
    })
    .catch((err) => {
      dispatch('core/showGeneralError', { err }, { root: true });
      reject(err);
    });
});

const toggleLoader = ({ commit, state }, conroledLoadingState) => {
  const { isLoading } = state.isLoading;

  const isNewLoading = typeof conroledLoadingState === 'undefined' ? !isLoading : conroledLoadingState;

  commit(constants.CORE_IS_LOADING, isNewLoading);
};

const toggleSidebar = ({ commit, state }, sidebarConfig = {}) => {
  const { visible } = state.sidebar;
  const sidebar = {
    ...state.sidebar,
    visible: !visible,
    position: 'right',
    ...sidebarConfig,
  };
  commit(constants.CORE_TOGGLE_SIDEBAR, sidebar);
};

const toggleNotification = ({ commit }, index) => {
  commit(constants.CORE_TOGGLE_NOTIFICATION, index);
};

const hideNotification = ({ commit }, index) => {
  commit(constants.CORE_TOGGLE_NOTIFICATION, index);
};

const addNotification = ({ commit, getters }, notification) => {
  const { notifications } = getters;
  const { message } = notification;
  const dublicatedNotification = _.find(notifications, {
    visible: true,
    message,
    type: 'danger',
  });

  if (dublicatedNotification) return;

  commit(constants.CORE_ADD_NOTIFICATION, {
    ...notification,
    visible: true,
  });
};

const showGeneralInfo = ({ dispatch }, data) => {
  const { resp = {}, notification = {} } = data;

  const respMessage = typeof resp.data === 'string' ? resp.data : '';

  let defaultNotification = {
    title: 'Success',
    message: respMessage || 'Data was successfully updated.',
    type: 'success',
  };

  if (resp.status === 200) {
    defaultNotification = {
      ...defaultNotification,
      message: respMessage || 'Data was successfully saved.',
    };
  }

  dispatch('addNotification', {
    ...defaultNotification,
    ...notification,
  });
};

const showGeneralError = ({ dispatch }, data) => {
  const { err = {}, notification = {} } = data;
  dispatch('addNotification', {
    title: err.response?.statusText || 'Error',
    message:
      err.response?.data?.title
      || err.response?.data
      || err.message
      || 'Server or network error, please try later.',
    type: 'danger',
    ...notification,
  });
};

export default {
  fetchPicture,
  fetchCountries,
  fetchConfig,
  fetchWarehouses,
  fetchLanguages,
  fetchCurrencies,
  fetchStateProvince,
  fetchStores,
  fetchCurrentStore,
  fetchSlider,
  toggleSidebar,
  hideNotification,
  toggleNotification,
  showGeneralError,
  showGeneralInfo,
  addNotification,
  toggleLoader,
};
